import { createSelector } from 'reselect';
import { selectCurrentCoursePath } from '../../location/CurrentCoursePath/selectors';
import {
  selectQuery,
  selectType,
  selectCurrentCustomDomain,
} from '../../location/selectors';
import { ROUTE_INSTITUTION_ADMIN } from '../../routeActions';
import { CUSTOM_DOMAIN_INSTITUTIONS } from '../constants';
import { selectCurrentInstitutionPrefixFromRoute } from '../CurrentInstitutionPrefix/selectors';

/**
 * Select the current institution path.
 */
export const selectCurrentInstitutionPath = createSelector(
  selectCurrentInstitutionPrefixFromRoute,
  selectCurrentCoursePath,
  selectQuery,
  selectType,
  selectCurrentCustomDomain,
  (
    institutionPrefix,
    coursePath,
    query,
    locationType,
    currentCustomDomain,
    customDomainInstitutions = CUSTOM_DOMAIN_INSTITUTIONS
  ) => {
    if (institutionPrefix) {
      return institutionPrefix;
    } else if (currentCustomDomain) {
      // Custom domain
      return customDomainInstitutions
        .find((item) => item.get('domain') === currentCustomDomain)
        .get('path');
    } else if (coursePath) {
      const segments = coursePath.split('/');
      if (segments[0] !== 'courses') {
        return segments[0];
      }
    } else if (
      locationType === ROUTE_INSTITUTION_ADMIN &&
      query.has('institution')
    ) {
      return query.get('institution').toLowerCase();
    }
    return null;
  }
);
